require('./register');
require('./login');
require('./forgot');
require('./account');
require('./addresses');
require('./companies');
require('./groups');
require('./group');
require('./ratings');
require('./coupons');
require('./reservation');
require('./newsletter');
require('./filters');
require('./search-widget');
require('./slider-search-widget');
require('./slider');
require('./cookies');
require('./offers');
require('./surveys');
require('./longterm-requests');
require('./vehicles-sales-requests');



// WEBPACK FOOTER //
// ./resources/assets/js/modules/index.js